import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InBaseFrwComponent} from '../inBaseFrwComponent';
import {Observable, of} from 'rxjs';
import {delay, first} from 'rxjs/operators';

@Component({
  selector: 'cmp-search',
  template: `<div class="search input-group input-group-sm">
  <input type="text"
         class="form-control"
         placeholder="Search"
         aria-label="Search"
         aria-describedby=""
         [(ngModel)]="model"
         (ngModelChange)="filterBySearch()">
  <div *ngIf='!hiddenButton' class="input-group-append cursor-pointer">
    <span class="input-group-text" id="" (click)="searchButton()">
      <i class="fa fa-search" aria-hidden="true"></i>
    </span>
  </div>
</div>
`,
  styles: [``]
})
export class SearchComponent extends InBaseFrwComponent implements OnInit {



  constructor() {
    super();
  }

  ngOnInit() {
  }

}
